<template>
  <v-app>
      <div class="animated fadeIn">

         <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

         <h1>{{ $t('nav.monitoring_customercontacts') }}</h1>

         <ddoClientList name="StartingList2" key="StartingList2" :loading="loading" :level="levels[0]"
            :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
            :customSlotNames="levels[0].customSlotNames"
            ref="myCEDList2"
            >

            <template slot="_actions2" slot-scope="props">
               <v-btn fab small @click="load_for_update(props.row._pk)"><v-icon x-large>mdi-pencil-circle</v-icon></v-btn>
            </template>

            <template slot="header" slot-scope="props">
               <!-- Must return something to override default slot content -->
               <span></span>
            </template>

            <template slot="searchengine" slot-scope="props">
               <v-card outlined max-width="400">
                  <h4>{{ $t('subtitles.filters') }} :</h4>
                  <v-col>
                     <v-text-field v-model="levels[0].searchValues.ctc_lastname" :label="$t('texts._lastname')" @change="filter_rows(0)">
                     </v-text-field>
                     <b-radio-group id="cus_active" v-model="levels[0].searchValues.cus_active" label="Client Actif/Non Actif" @change="filter_rows(0)">
                        <b-radio value="">Tous</b-radio>
                        <b-radio value="true">Actif</b-radio>
                        <b-radio value="false">Non Actif</b-radio>
                     </b-radio-group>
                  </v-col>
               </v-card>
            </template>

            <template slot="cus_name" slot-scope="props">
               <b-checkbox disabled v-model="props.row.cus_active">{{ props.row.cus_name}}</b-checkbox>
            </template>

            <template v-slot:dialogform="{ row, level }">
               <v-dialog v-model="levels[0].dialogValues.dialogShow" max-width="700">
                  <CardUpdatableContact ref="MyCardContact" :row="levels[0].row" :level="levels[0]" name="Contact" data-app="true" persistent
               />
               </v-dialog>
            </template>

         </ddoClientList>

      </div>
   </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue'
import ddoClientList from '@/components/ddoClientList.vue';
import { Event } from '@/components/ddoClientList.vue';
import CardUpdatableContact from '@/components/partials/CardUpdatableContact.vue';

let initial_row = {}

export default {
   name: 'customercontact',
   components: {
      ddoAlert,
      ddoWaiting,
      ddoClientList,
      CardUpdatableContact,
   },
   data: () => {
      return {
         _this: null,
         loading: false,

         /* 
         * LEVEL 1 : all for ddoClientList : columns, options, callbacks
         */
         levels: [

         {
            /* 
             * LEVEL 0 :
             */
            api_code: 'contact',
            api_prefix: 'ctc',
            row: {},
            level: 0,
            errors: [],
            columns: [ '_actions2', 'ctc_lastname', 'ctc_firstname', 'cus_name', 'ctc_organizationname', '_count' ],
            customSlotNames: ['_actions2','cus_name'],
            searchValues: {
               ctc_lastname: null,
               cus_active: null,
            },
            options: {
               showChildRowToggler: false,
               withChild: false,
               headings: {
                  _pk: i18n.t('headers.actions'),
                  ced_pk: '#',
                  ctc_firstname: i18n.t('texts.ctc_firstname'),
                  ctc_lastname: i18n.t('texts.ctc_lastname'),
                  ctc_organizationname: i18n.t('texts.ctc_organizationname'),
                  cus_name: i18n.t('texts.cus_name'),
                  cus_active: '',
                  _count: i18n.t('texts.ctc_affectations'),
                  _update: i18n.t('headers.updated_on'),
               },
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               uniqueKey: 'ced_pk',
               perPage: 100,
               perPageValues: [100,200,500],
               customFilters: [{
                  name: 'search',
                  callback: function (row, query) {
                     let $ret = true;
                     if ( $ret && query.cus_active!=null && query.cus_active!='' ) {
                        if ( query.cus_active=="true" && row.cus_active==false ) { $ret = false; }
                        if ( query.cus_active=="false" && row.cus_active==true ) { $ret = false; }
                     }
                     if ( query.ctc_lastname && query.ctc_lastname!=null ) {
                        $ret = false;
                        if ( row.ctc_lastname && row.ctc_lastname.toLowerCase().indexOf(query.ctc_lastname.toLowerCase())>=0 ) { $ret = true; }
                        if ( row.ctc_organizationname && row.ctc_organizationname.toLowerCase().indexOf(query.ctc_lastname.toLowerCase())>=0 ) { $ret = true; }
                     }
                     return $ret;
                  }
               }],
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  select: i18n.t('texts.ctc_select_title'),
                  create: i18n.t('texts.ctc_create_title'),
                  update: i18n.t('texts.ctc_update_title'),
                  delete: i18n.t('texts.ctc_delete_title'),
               },
               texts: {
                  create_item: i18n.t('texts.ctc_create_item'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               readonly: false,
               header_value_function: function(row) { return row['ctc_email']; }
            },
         }

         ],

         model: {},
         dialogShow: false,
         dialogId: null,
         dialogcode: null,

         useVuex: false,
         theme: 'bootstrap4',
         template: 'default',
      }
   },

   created() {
      this._this = this;
      this.levels[0].callbacks.refresh_rows   = this.refresh_rows;
      this.levels[0].callbacks.configure_form = this.configure_form;
      this.levels[0].callbacks.prepare_update = this.prepare_update;    
      this.levels[0].callbacks.show_dialog    = this.show_dialog;
   },

   mounted() {
   },

   methods: {

      async refresh_rows(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code);
         this.loading = false;
         return { errorinfos, api_response }
      },

      configure_form(level,f_disabled,f_create,f_update,f_delete) {
         let _dV = this.levels[level].dialogValues;
         _dV.form_disabled = f_disabled;
         _dV.form_create   = f_create;
         _dV.form_update   = f_update;
         _dV.form_delete   = f_delete;
         this.levels[level].dialogValues = _dV;
      },

      show_dialog(level,show) {
         let _dV = this.levels[level].dialogValues;
         _dV.header_value = _dV.header_value_function(this.levels[level].row);
         _dV.dialogShow   = show;
         this.levels[level].dialogValues = _dV;
      },

      async load_for_update(_pk,origin=null) {
         this.$emit('loading',true);
         var { errorinfos, api_response } = await this.$api.getRow(this.$router,this.levels[0].api_code,_pk);
         this.$emit('loading',false);

         //await this.refresh_ctc_dropdowns();
         
         this.levels[0].callbacks.configure_form(this.levels[0].level,false,false,true,false);

         if ( api_response.error==0 && api_response.row ) {
            this.levels[0].row = api_response.row;
            if ( this.levels[0].callbacks.prepare_update ) {
               this.levels[0].callbacks.prepare_update(api_response.row.cus_pk,_pk,api_response.row,origin);
            }
            this.levels[0].callbacks.show_dialog(this.levels[0].level,true);
         } else {
            this.errors = [errorinfos];
         }
      },

      async prepare_update(parentKey=null) {
         this.levels[0].row.cus_pk = parentKey;
         this.parse_phones(this.levels[0].row);

         this.levels[0].errors = [];
      },

      parse_phones(row) {
         /*
          * We recreate the 'phones' objet, in current 'row'
          */
         row.phones = { ctc_phone_fixed_phone: { country: "FR" }, ctc_phone_cell_phone: { country: "FR" } };
         /*
          * And re-scan phones : ctc_phone_fixed_phone, ...
          */
         if ( row.ctc_phone_fixed_phone!=null ) {
            let parse = parsePhoneNumberFromString(row.ctc_phone_fixed_phone);
            if ( parse ) {
               row.phones.ctc_phone_fixed_phone = parse;
            }
         }
         if ( row.ctc_phone_cell_phone!=null ) {
            let parse = parsePhoneNumberFromString(row.ctc_phone_cell_phone);
            if ( parse ) {
               row.phones.ctc_phone_cell_phone = parse;
            }
         }
      },

      filter_rows(level) {
         Event.$emit('vue-tables.filter::search', this.levels[level].searchValues);
      },

   }
}
</script>